module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/vertical-pill/vertical-pill.component.scss
// module id = ./src/app/features/tabination/vertical-pill/vertical-pill.component.scss
// module chunks = main